/* ============================================
   Lynk Product Card — shared JS
   Variant switching, qty, AJAX ATC, price update
   ============================================ */
(function() {
  if (window.lynkCardInit) return;
  window.lynkCardInit = true;

  function formatMoney(cents) {
    return '\u20b9' + (cents / 100).toFixed(2);
  }

  function updateCartBubble() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var bubbles = document.querySelectorAll('.lynk-header__cart-count, .cart-count-bubble [aria-hidden]');
        bubbles.forEach(function(el) { el.textContent = cart.item_count; });
        // Also update Shopify native cart-icon-bubble if present
        document.querySelectorAll('.cart-count-bubble').forEach(function(el) {
          var hidden = el.querySelector('[aria-hidden]');
          if (hidden) hidden.textContent = cart.item_count;
        });
        document.querySelectorAll('.lynk-header__cart-count').forEach(function(el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? '' : 'none';
        });
      });
  }

  function getActiveVariantId(card) {
    var activePill = card.querySelector('.lynk-pcard__size-pill.active');
    if (activePill) return activePill.getAttribute('data-variant-id');
    return card.getAttribute('data-variant-id');
  }

  function initCard(card) {
    var qtyInput = card.querySelector('[data-qty-input]');
    var qtyDisplay = card.querySelector('[data-qty-display]');
    var minus = card.querySelector('[data-qty-minus]');
    var plus = card.querySelector('[data-qty-plus]');
    var atcBtn = card.querySelector('.lynk-pcard__atc');

    if (minus && qtyInput) {
      minus.addEventListener('click', function() {
        var v = parseInt(qtyInput.value, 10);
        if (v > 1) {
          qtyInput.value = v - 1;
          if (qtyDisplay) qtyDisplay.textContent = v - 1;
        }
      });
    }
    if (plus && qtyInput) {
      plus.addEventListener('click', function() {
        var v = parseInt(qtyInput.value, 10) + 1;
        qtyInput.value = v;
        if (qtyDisplay) qtyDisplay.textContent = v;
      });
    }

    if (atcBtn) {
      atcBtn.addEventListener('click', function() {
        if (atcBtn.disabled) return;
        var variantId = getActiveVariantId(card);
        if (!variantId) return;
        var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;

        var originalHTML = atcBtn.innerHTML;
        atcBtn.textContent = 'Adding...';
        atcBtn.disabled = true;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: 'id=' + variantId + '&quantity=' + qty
        })
        .then(function(r) {
          if (!r.ok) throw new Error('Cart error');
          return r.json();
        })
        .then(function() {
          atcBtn.textContent = 'Added!';
          setTimeout(function() { atcBtn.innerHTML = originalHTML; atcBtn.disabled = false; }, 1500);
          updateCartBubble();
        })
        .catch(function() {
          atcBtn.innerHTML = originalHTML;
          atcBtn.disabled = false;
        });
      });
    }

    // Size pill — update price and variant
    card.querySelectorAll('.lynk-pcard__size-pill').forEach(function(pill) {
      pill.addEventListener('click', function() {
        card.querySelectorAll('.lynk-pcard__size-pill').forEach(function(p) { p.classList.remove('active'); });
        pill.classList.add('active');

        var priceEl = card.querySelector('.lynk-pcard__price');
        var compareEl = card.querySelector('.lynk-pcard__compare');
        var discountEl = card.querySelector('.lynk-pcard__discount');
        var price = parseInt(pill.getAttribute('data-price') || '0', 10);
        var compare = parseInt(pill.getAttribute('data-compare') || '0', 10);

        if (priceEl && price) priceEl.textContent = formatMoney(price);
        if (compareEl) {
          if (compare > price) {
            compareEl.textContent = formatMoney(compare);
            compareEl.style.display = '';
            if (discountEl) {
              var pct = Math.round((compare - price) * 100 / compare);
              discountEl.textContent = pct + '% Off';
              discountEl.style.display = '';
            }
          } else {
            compareEl.style.display = 'none';
            if (discountEl) discountEl.style.display = 'none';
          }
        }
      });
    });
  }

  function initAll() {
    document.querySelectorAll('.lynk-pcard').forEach(initCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
